import api from '@/api'

const obtainToken = function (credentials) {
  return api.post('/auth/obtain-token', credentials, {skipAuthentification: true})
}

const refreshToken = function (token) {
  let data = {
    token: token,
  }

  return api.post('/auth/refresh-token', data, {skipAuthentification: true})
}

const verifyToken = function (token) {
  let data = {
    token: token,
  }

  return api.post('/auth/verify-token', data, {skipAuthentification: true})
}

const forgotPassword = function (credentials) {
  return api.post('/auth/forgot-password', credentials, {skipAuthentification: true})
}

const resetPassword = function (credentials) {
  return api.post('/auth/reset-password', credentials, {skipAuthentification: true})
}

export default {
  obtainToken,
  refreshToken,
  verifyToken,
  forgotPassword,
  resetPassword
}
